var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('item-selector',_vm._b({attrs:{"outlined":""},on:{"search":v => _vm.search = v},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}},'item-selector',{
            loading: _vm.loading,
            disabled: _vm.disabled,
            action: _vm.action,
            label: _vm.label,
            multiple: false,
            extraParams: _vm.extraParams,
            itemText: _vm.itemText,
            itemValue: _vm.itemValue,
            queryParameter: _vm.queryParameter,
            returnObject: true,
        },false)),_vm._v(" "),_c('v-data-table',_vm._b({scopedSlots:_vm._u([{key:"item.actions",fn:function({ item }){return [_c('v-btn',{attrs:{"icon":"","color":"error"},on:{"click":function($event){return _vm.deleteItem(item)}}},[_c('v-icon',[_vm._v("delete")])],1)]}}])},'v-data-table',{
            items: _vm.value,
            headers: _vm.headers,
            loading: _vm.loading,
            //search: search,
        },false))],1),_vm._v(" "),_vm._l((_vm.value),function(e,index){return (_vm.name)?_c('input',_vm._b({key:index,attrs:{"type":"hidden"}},'input',{
        name: `${_vm.name}[]`,
        value: e[_vm.itemValue],
    },false)):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }